<script setup lang="ts">
import { computed } from 'vue'

import { Badge, Button, Figure, Image, ImageSrcSet, Picture } from '@toni/brand-ui'
import { BauerProductCard, PurchaseOptions } from '@toni/commerce-api-types'

import { scrollToAnchor } from '../../utils/scroll'
import ProductCardTopListPurchaseCTA from './ProductCardTopListPurchaseCTA.vue'

const props = defineProps<{
  productCard: BauerProductCard,
  purchaseOptions: PurchaseOptions
}>()
const purchaseOptions = computed(() => props.purchaseOptions || [])
const primaryPurchaseOption = purchaseOptions.value[0]
</script>

<template>
  <div class="flex items-center justify-start w-full py-[0.5rem] gap-2 border-b">
    <Image v-if="productCard?.images?.[0]"
           class="max-w-[4rem] max-h-[4rem]">
      <Figure class="flex flex-1 mb-2">
        <Picture class="flex-1 flex items-center justify-start w-[4rem] h-[4rem]">
          <ImageSrcSet>
            <img :src="productCard?.images?.[0]?.url"
                 :alt="productCard?.images?.[0]?.altText"
                 class="max-w-[4rem] max-h-[4rem]">
          </ImageSrcSet>
        </Picture>
      </Figure>
    </Image>
    <div class="flex flex-col sm:flex-row flex-1 gap-1 sm:gap-4">
      <div class="flex flex-col flex-1">
        <Badge v-if="productCard.label"
               type="text"
               variant="ghost"
               class="text-xs font-medium leading- tracking-wide py-[0.125rem] line-clamp-1"
               :title="productCard.label">
          {{ productCard.label }}
        </Badge>
        <h3 class="font-heading text-lg font-medium leading-snug text-foreground line-clamp-2"
            :title="productCard?.title">
          {{ productCard?.title }}
        </h3>
      </div>
      <div class="flex justify-between items-center leading-none gap-1 sm:gap-4">
        <div>
          <Button variant="link"
                  class="max-w-full text-sm font-medium leading-none gap-1 md:gap-1.5"
                  @click="scrollToAnchor(productCard.title || '')">
            <span class="truncate overflow-hidden whitespace-nowrap">
              {{ $t('commerce.readReview') }}
            </span>
            <slot name="icon" />
          </Button>
        </div>
        <div>
          <ProductCardTopListPurchaseCTA
            v-if="primaryPurchaseOption"
            :purchase-option="primaryPurchaseOption" />
        </div>
      </div>
    </div>
  </div>
</template>
